var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz__sidebar"},[_c('ul',_vm._l((_vm.questions),function(question,i){return _c('li',{key:i,class:{ active: _vm.isCurrentStep(i) }},[_c('p',[_vm._v(_vm._s(i + 1)+". "+_vm._s(question))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("option_text")(_vm.getAnswer(i)))))])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3da8af14","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/app/components/sidebar.vue
// module id = 42
// module chunks = 0